import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { AuthenticationService, CredentialService, OrderService, PrinterService, ShipmentService } from '../../../services';

import { industrialTemplateIds } from 'ngrx/industrial-template-ids';
import { FedExServiceTypeMapping, shipmentDisplayTypes } from 'ngrx/shipment-options';
import { BsModalService } from 'ngx-bootstrap';
import { stateCodes } from '../../../../ngrx/state-codes';
import { environment } from '../../../../environments/environment';


const labelShapes = {
    1 : 'Rectangle',
    2 : 'Round',
    3 : 'Oval',
    4 : 'Square',
    5 : 'Custom',
}
@Component({
  selector: 'rfid-packing-slip-modal',
  templateUrl: 'rfid-packing-slip-modal.component.html',
  styleUrls:   ['rfid-packing-slip-modal.component.scss']
})
export class RFIDPackingSlipModal implements OnInit, OnDestroy {
  @Input('jobs')            jobs;
  @Input('order')           order;
  @Input('shipment')        shipment;
  @Input('page')            page;
  initSubscriptions      : Subscription[];
  process                : Observable<string>;
  shipmentDetailsView    : Observable<any>;
  labelsPerLane          : number;
  brandLogo              : string;
  logoWidth              : string;
  layout                 : string;
  stateCodes             : any = stateCodes;
  shipmentDisplayTypes   : any = shipmentDisplayTypes;
  FedExServiceTypeMapping: any = FedExServiceTypeMapping;
  packingSlipPrinting    : boolean;
  labelShapes            : any = labelShapes;
  packingSlipMsg         : string;
  splitTotalQty          : Object = {};
  mtOrderNumber          : string;
  customerPO             : string;
  idcSalesOrderNumber    : string;                         //ID&C
  idcPO                  : string;                         //ID&C
  info                   : Object = {};                    //info for either mastertag or id&c 
  thumbnailURLs          : string[];
  industrialTemplateIds  : any = industrialTemplateIds;
  phoneNumber            : string;
  constructor(
    private orderService     : OrderService,
    private authService      : AuthenticationService,
    private shipmentService  : ShipmentService,
    private printerService   : PrinterService,
    private modalService     : BsModalService,
    private credentialService: CredentialService,
  ) {
    this.process             = this.authService.getCurrentProcess();
    this.shipmentDetailsView = this.shipmentService.getShipmentDetailsView();
  }
  
  ngOnInit(): void {
    console.log('this.jobs', this.jobs)
    console.log('this.order', this.order)
    console.log('this.shipment', this.shipment)

    let customerInfo;
    switch (this.order.customer.outsource) {
      case 'idcband':
        customerInfo = {
          phoneNumber: '(941) 739-6935',
          brandLogo: 'https://s3.us-east-1.amazonaws.com/impreso.sheet.asset/ID%26C+Logo.png'
        };
        break;
      case 'rfid':
        customerInfo = {
          phoneNumber: '(888) 249-3068',
          brandLogo: 'https://s3.us-east-1.amazonaws.com/impreso.sheet.asset/RFID_Hotel_RLogo_black.png'
        };
        break;
      default:
        customerInfo = {
          phoneNumber: '(888) 249-3068',
          brandLogo: 'https://s3.us-east-1.amazonaws.com/impreso.sheet.asset/RFID_Hotel_RLogo_black.png'
        };
    }

    this.phoneNumber = customerInfo.phoneNumber;

    this.initSubscriptions = [
      this.process
        .subscribe(process => {
          this.layout = process;
          this.brandLogo = customerInfo.brandLogo;
          this.logoWidth = '320';
        }),

      this.shipmentDetailsView
        .subscribe((shipmentDetailsViewState: any) => {
          console.log(shipmentDetailsViewState)
          const {
            // addressValidationMsg,
            packingSlipPrinting,
          } = shipmentDetailsViewState;
          this.packingSlipPrinting      = packingSlipPrinting;
        })
      ]
      
      this.jobs.forEach((job) => {
        let TotalQty = 0;
        console.log(job.splitJobs)
        if(job.isSplit && job.splitJobs.length){
          job.splitJobs.forEach((split) => {
            TotalQty += Number(split.label_qty);
          })
          this.splitTotalQty[job.id] = TotalQty;
        } 

        if (job.itemInfo) {
          this.info[job.id] = [];
          
          const itemDetailsName = {
            product_group : 'Product Group',
            mt_item : 'MT Item',
            drawing_number : 'Drawing Number',
            description : 'Description',
            retail_price : 'Retail Price',
            dor : 'DOR',
          } 
          
          Object.keys(job.itemInfo).map((key) => {
            if(job.itemInfo[key] && key != 'preferred_roll_diameter'){
              this.info[job.id].push(`${itemDetailsName[key]}: ${job.itemInfo[key]}`)
            }
          })
        }

      });
  }

  ngOnDestroy(): void {
    this.initSubscriptions.forEach(subscription => subscription.unsubscribe());
    console.log("Destroying...");
  }

  printPackingSlip(qty: number): void {
    if (!this.packingSlipPrinting) {
      this.printerService.printPackingSlip(
        this.jobs,
        this.order,
        this.shipment,
        qty,
        true, // isRfid
        'Tray 2'
      );
    }
  }
}



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/modals/rfid-packing-slip-modal/rfid-packing-slip-modal.component.ts